import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const Footer = () => {
  return (
    <Box position="static" sx={{  padding: '0px !important', minHeight: '55px',borderTop: '1px solid rgb(212, 212, 212)' }}>
      <Toolbar sx={{ justifyContent: 'center', minHeight: '50px !important' ,padding: '0px !important'}}>
        <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)'  }}>
          Copyright © 2025-2026. All rights reserved..
        </Typography>
      </Toolbar>
    </Box>
  );
};

export default Footer;
